// extracted by mini-css-extract-plugin
module.exports = {"root":"ProcedureTreatmentSummary_root__2fb_-","row":"ProcedureTreatmentSummary_row__2HIVc"};